import React from 'react';
import { useTranslations } from '@/shared/ui/selects/select-options/hooks';
import { BodyTextRegularB } from '@/shared/ui/typography2';
import { interpolateTemplate } from '../../utils/interpolate-template';
import { DescriptionSection } from './styles';
import { WhiteText } from '../bonus-conditions/styles';

export const WelcomeBonusDescription = () => {
  const { translations } = useTranslations();
  const parts = translations?.bonus?.page_content?.welcome_bonus_deck?.parts;

  if (!Array.isArray(parts)) return null;

  return (
    <DescriptionSection>
      {parts.map((part, index) => (
        <BodyTextRegularB key={index} color='#AFAFAF'>
          {interpolateTemplate(part.template, part.variables, WhiteText)}
        </BodyTextRegularB>
      ))}
    </DescriptionSection>
  );
};
